// Import GSAP core and the ScrollTrigger plugin
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';



import Isotope from 'isotope-layout';
// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);



jQuery(document).ready(function($) {
    let totalProjects = 999, // Initial number of stories to show
        moreEachPage = 999,  // Number of stories to load on each scroll
        items = $('.stories-item'), // Class for the project items
        loading = false, // Flag to prevent multiple simultaneous requests
    allItemsLoaded = false;

    // Function to handle displaying the currently visible stories
    function handleVisibleProjects() {
        items.each(function(i, e) {
            if (i < totalProjects && !$(e).hasClass('animated')) {
                // Mark the item as animated to prevent re-animation
                $(e).addClass('animated');

                // Create ScrollTrigger for each item
                ScrollTrigger.create({
                    trigger: e, // Element to trigger on
                    start: "top 100%", // Trigger when top of the element hits the viewport
                    // markers: true, // Uncomment to see markers
                    onEnter: function() {
                        // GSAP animation for individual item
                        gsap.to(e, {
                            duration: 0.75,
                            autoAlpha: 1,
                            x: 0,
                            y: 0,
                            ease: "power1.out"
                        });
                    }
                });
            }
        });
    }


    // Check if any .stories-item elements exist before proceeding
    if (items.length > 0) {
        // Set initial state for project items (hidden with y offset)
        gsap.set(".stories-item", { y: 100, autoAlpha: 0 });

        // Initial load of visible stories
        handleVisibleProjects();

        // Infinite scroll event
        $(window).on('scroll', function() {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && !loading) {
                loading = true; // Prevent further requests during load

                // Increase the total stories count to show more on scroll
                totalProjects += moreEachPage;

                // Handle the newly visible stories
                handleVisibleProjects();

                // Reset loading flag after a short delay
                setTimeout(function() {
                    loading = false;
                }, 500);
            }
        });
    } else {
        // console.log('No project items found on the page.');
    }


// Custom Isotope Item and LayoutMode Overrides
    Isotope.Item.prototype._create = function() {
        this.id = this.layout.itemGUID++;
        this._transn = {
            ingProperties: {},
            clean: {},
            onEnd: {}
        };
        this.sortData = {};
    };

    Isotope.Item.prototype.layoutPosition = function() {
        this.emitEvent('layout', [this]);
    };

    Isotope.prototype.arrange = function(opts) {
        this.option(opts);
        this._getIsInstant();
        this.filteredItems = this._filter(this.items);
        this._isLayoutInited = true;
    };

// Custom LayoutMode that does not position items
    Isotope.LayoutMode.create('none');

// Initialize Isotope

// Initialize Isotope
    var $grid = $('.stories-list').isotope({
        itemSelector: '.stories-item',
        layoutMode: 'none'
    });

    // Check if any .stories-item elements exist before proceeding
    if (items.length > 0) {
        // Set initial state for all project items (hidden with y offset)
        gsap.set(".stories-item", { y: 100, autoAlpha: 0 });

        // Initial load of visible stories
        handleVisibleProjects();

        // Infinite scroll event
        $(window).on('scroll', function() {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 500 && !loading) {
                loading = true;

                // Load more items
                totalProjects += moreEachPage;

                // Get current filter value
                const currentFilter = $('#stories-filters .is-checked').attr('data-filter');
                handleVisibleProjects(currentFilter);

                setTimeout(function() {
                    loading = false;
                }, 500);
            }
        });
    }

    // Bind filter button click
    $('#stories-filters').on('click', 'button', function() {

        // Smooth scroll to top
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        var filterValue = $(this).attr('data-filter');

        // If showing all items, ensure all items are loaded first
        if (filterValue === '*' && !allItemsLoaded) {
            totalProjects = items.length; // Set to show all items
            allItemsLoaded = true;
        }

        // Reset GSAP animations for filtered items
        items.removeClass('animated');
        gsap.set(".stories-item", { y: 100, autoAlpha: 0 });

        // Apply the filter
        $grid.isotope({ filter: filterValue });

        // Handle animations for filtered items
        $grid.one('arrangeComplete', function() {
            handleVisibleProjects(filterValue);
        });
    });

    // Change is-checked class on buttons
    $('.button-group').each(function(i, buttonGroup) {
        var $buttonGroup = $(buttonGroup);
        $buttonGroup.on('click', 'button', function() {
            $buttonGroup.find('.is-checked').removeClass('is-checked');
            $(this).addClass('is-checked');
        });
    });

});
